import { useCallback } from 'react';
import { TextFieldProps } from '@mui/material';
import { NumberTextField } from 'components/@shared/NumberTextField';
import { useField } from 'formik';

type Value = string | number | undefined;

interface Props extends Omit<TextFieldProps, 'ref' | 'onChange' | 'type'> {
    name: string;
    defaultValue?: Value;
    value?: Value;
}

export const FormNumberTextField = ({ rows, ...props }: Props) => {
    const [field, meta, helpers] = useField(props.name);

    const handleChange = useCallback((value: string) => helpers.setValue(value), [helpers]);

    return (
        <NumberTextField
            rows={rows}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
            {...props}
            {...field}
            onChange={handleChange}
        />
    );
};
